import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85530f88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ph-price-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Price: ")
const _hoisted_3 = {
  key: 1,
  class: "ph-price-error"
}
const _hoisted_4 = {
  key: 2,
  class: "ph-price"
}

import { ConfigItem, ContractPriceItem, WebsiteItem } from '@/types';
    import { PreHangCartOptions } from '@/types/preHang';
    import { PropType, ref, watch } from 'vue';
    import { debounce } from 'lodash';
    import usePreHangService from '@/services/pre-hang-service';
    import ButtonSpinnerComponent from '@/components/ButtonSpinnerComponent.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PreHangPrice',
  props: {
        door: { type: Object as PropType<WebsiteItem | ConfigItem | ContractPriceItem>, required: true },
        preHangOptions: { type: Array as PropType<PreHangCartOptions[]>, required: true },
        priceAdjust: { type: Number, required: false, default: 100 }
    },
  setup(__props) {

const props = __props

    

    const phService = usePreHangService()
    const price = ref<string>('0')
    const callCount = ref<number>(0)
    const hasError = ref<boolean>(false)

    watch(() => props.preHangOptions, debounce(async () => {
        callCount.value++
        const data: any = {
            ...props.door
        }
        data.preHangQuantities = []
        data.preHangOptions = props.preHangOptions
        const result = await phService.getPrice(data)
        if(isNaN(result) && result > 0) {
            hasError.value = true
        } else {
            hasError.value = false
            price.value = (result * (props.priceAdjust / 100)).toFixed(2)
        }
        callCount.value--
    }, 300), {immediate: true})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _hoisted_2,
      (callCount.value > 0)
        ? (_openBlock(), _createBlock(ButtonSpinnerComponent, {
            key: 0,
            visible: true
          }))
        : (hasError.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Error Fetching Price"))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "$" + _toDisplayString(price.value), 1))
    ])
  ]))
}
}

})